import React from 'react';
import PropTypes from 'prop-types';
import Ionicon from 'react-ionicons';
import * as networkHelpers from '../../../../../../helpers/networkHelpers';
import { generalHelpers } from '../../helpers';

export const FormButtons = props => {
	const {
			handleEditing,
			handleDelete,
			handleSave,
			handleSubmit,
			type,
			index,
			personId,
			id,
			networkId,
		} = props,
		networkName = networkHelpers.setCurrentNetwork(networkId);
	return networkName === 'TCH' ? (
		<ul className="buttons-left">
			{type === 'UPDATE' && (
				<li>
					<button
						className="theme-button secondary"
						type="button"
						onClick={() => handleDelete(personId, index, id, 'DELETE')}
					>
						Delete
						<Ionicon icon="ion-android-delete button-icon" />
					</button>
				</li>
			)}
			<li>
				<button
					className="theme-button"
					type="button"
					onClick={() => handleEditing()}
				>
					Cancel
					<Ionicon icon="ion-android-cancel button-icon" />
				</button>
			</li>
			<li>
				<button
					className="theme-button"
					type="submit"
					onClick={handleSubmit(handleSave)}
				>
					Save
					<Ionicon icon="ion-android-checkmark-circle" />
				</button>
			</li>
		</ul>
	) : (
		<ul className="buttons-left">
			{type === 'UPDATE' && (
				<li>
					<button
						className="theme-button secondary"
						type="button"
						onClick={() => handleDelete(personId, index, id, 'DELETE')}
					>
						Delete
						<i className="fa fa-times button-icon" />
					</button>
				</li>
			)}
			<li>
				<button
					className="theme-button"
					type="button"
					onClick={() => handleEditing()}
				>
					Cancel
					<i className="fa fa-trash button-icon" />
				</button>
			</li>
			<li>
				<button
					className="theme-button"
					type="submit"
					onClick={handleSubmit(handleSave)}
				>
					Save
					<i className="fa fa-check-circle button-icon" />
				</button>
			</li>
		</ul>
	);
};

export const AddButtonAchievements = props => {
	const { handleAdding, isOpen } = props;
	return (
		<button
			type="button"
			data-position="right"
			className="btn btn-circle btn-add header-btn"
			onClick={() => handleAdding()}
		>
			<span className="icon">
				<Ionicon icon={isOpen ? 'ion-android-close' : 'ion-android-add'} />
			</span>
		</button>
	);
};

export const FormButtonsAchievements = props => {
	const { onCancel } = props;
	return (
		<ul className="buttons-left">
			<li>
				<button
					className="theme-button"
					type="button"
					onClick={() => onCancel()}
				>
					Cancel
					<i className="fa fa-trash button-icon" />
				</button>
			</li>
			<li>
				<button className="theme-button" type="submit">
					Save
					<i icon="fa fa-check-circle button-icon" />
				</button>
			</li>
		</ul>
	);
};

export const AddButton = props => {
	const { handleEditing } = props,
		createId = generalHelpers.randomNum;
	return (
		<button
			type="button"
			data-position="right"
			className="btn btn-cirlce btn-add btn-header"
			onClick={() => handleEditing(true, createId)}
		>
			<span className="icon">
				<Ionicon icon="ion-android-add" />
			</span>
		</button>
	);
};

export const EditButton = props => {
	const { handleEditing, index } = props;
	return (
		<button
			type="button"
			data-position="right"
			className="btn btn-circle btn-edit"
			onClick={() => handleEditing(true, index)}
		>
			<span className="icon">
				<Ionicon icon="ion-edit" />
			</span>
		</button>
	);
};

export const CloseButton = props => {
	const { handleEditing } = props;
	return (
		<button
			type="button"
			data-position="right"
			className="btn btn-cirlce btn-add"
			onClick={() => handleEditing()}
		>
			<span className="icon">
				<Ionicon icon="ion-android-close" />
			</span>
		</button>
	);
};

export const StandardButton = props => {
	const { label, handler, endorsement, personId, type, publish } = props;

	return (
		<ul className="buttons-right">
			<li>
				<button
					type="button"
					className="theme-button"
					onClick={() => handler(personId, endorsement, type, publish)}
				>
					<span className="label">{label}</span>
				</button>
			</li>
		</ul>
	);
};

export const EndorsementsPublishButton = props => {
	const { hideButtonsFromMain, body, handleData } = props,
		{ is_visible, id } = body;
	const endorsementData = {
		id,
		is_visible,
		type: 'UPDATE',
		stayOpen: true,
	};
	return (
		!hideButtonsFromMain && (
			<button
				type="button"
				className="btn btn-circle btn-edit"
				onClick={() => handleData(endorsementData)}
			>
				<span className="icon">
					{is_visible ? (
						<Ionicon icon="ion-eye-disabled" />
					) : (
						<Ionicon icon="ion-eye" />
					)}
				</span>
				<span className="label">{is_visible ? 'Unpublish' : 'Publish'}</span>
			</button>
		)
	);
};

export const EndorsementsDeleteButton = props => {
	const { text, hideButtonsFromMain, hideDeleteButton, handleClick } = props;
	return (
		<div>
			{hideButtonsFromMain || hideDeleteButton ? null : (
				<button
					type="button"
					className="btn btn-circle btn-delete"
					onClick={() => handleClick()}
				>
					<span className="icon">
						<Ionicon icon="ion-android-delete" />
					</span>
					<span className="label">{text}</span>
				</button>
			)}
		</div>
	);
};

export const HOCButton = props => {
	const { handleEditing, text, icon } = props;
	return (
		<a className="btn-inline-icon" onClick={() => handleEditing(true)}>
			{text}
		</a>
	);
};

export const HOCFormButtons = props => {
	const {
		handleEditing,
		handleSubmit,
		handleData,
		numberButtons,
		pristine,
		submitting,
		id,
		onCancel,
		handleAdding,
		useNetworkIdInsteadOfSummaryIdForDelete,
		network_id,
		primary_industry,
	} = props;

	const cancelForm = handleEditing || onCancel;
	const saveForm = handleData || handleAdding;
	const deleteId =
		(useNetworkIdInsteadOfSummaryIdForDelete ? network_id : id) ||
		(primary_industry && primary_industry.id);

	return (
		<ul className="buttons-left">
			{numberButtons && (
				<li>
					<button
						className="theme-button secondary"
						type="button"
						onClick={() => handleData(deleteId)}
					>
						Delete
						<i className="fa fa-times button-icon" />
					</button>
				</li>
			)}
			<li>
				<button
					className="theme-button"
					type="button"
					onClick={() => cancelForm(false)}
				>
					Cancel
					<i className="fa fa-trash button-icon" />
				</button>
			</li>
			<li>
				<button
					className="theme-button"
					type="submit"
					onClick={handleSubmit && handleSubmit(saveForm)}
					disabled={pristine || submitting}
				>
					Save
					<i className="fa fa-check-circle button-icon" />
				</button>
			</li>
		</ul>
	);
};

export const EndorsementsButton = props => {
	const { handleEditing } = props;
	return (
		<button
			className="theme-button"
			type="button"
			onClick={() => handleEditing(true)}
		>
			Manage Endorsements
		</button>
	);
};

export const SideNavContactButton = props => {
	const { handleOnClick } = props;
	return (
		<button className="theme-button" onClick={handleOnClick}>
			Contact
			<i className="fa fa-telegram-plane button-icon" />
		</button>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/buttons.js